export const getPrimaryField = table => {
  if (table.fields) {
    return Object.keys(table.fields).filter(key => {
      return table.fields[key].isPrimaryField
    })[0]
  }
}

export const ALL_RELATIONSHIPS_BUILDER = 'ALL_RELATIONSHIPS_BUILDER'
